import React from 'react';

import StepTransactionQualification from '../../components/Setup/StepTransactionQualification';


function ActivitySetupTransactionQualificationView() {
  return (
    <StepTransactionQualification />
  );
}

export default ActivitySetupTransactionQualificationView;
